export const STEPS = {
  POWER: 'POWER',
  PRESENTATION: 'PRESENTATION',
  QUANTITY: 'QUANTITY'
};

export const STEP_TITLES = {
  [STEPS.POWER]: "Potencia",
  [STEPS.PRESENTATION]: "Presentación",
  [STEPS.QUANTITY]: "Cantidad de cajas"
};

export const defaultPresentation = { name: null, regNo: null };